if(document.getElementById('pdpIframe')){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const propertyId = document.getElementById('pdpIframe').getAttribute('data-propertyid');
    const userRoute = urlParams.get('ibuy_ab_vst') ? `&ab_vst=${urlParams.get('ibuy_ab_vst')}` : '';
    let loaded = false;

    const loadDeferredIframe = () => {
        let iframe = document.createElement('iframe');
        iframe.src = `/sell/sellers-marketplace/pdp-frame?propertyId=${propertyId}${userRoute}`;
        iframe.onload = () => {
            const hasChildAlready = document.getElementById('pdpIframe').querySelector('iframe');
            if(!loaded && hasChildAlready === null){
                document.getElementById('pdpIframe').append(document.getElementById('spotOffer'));
                loaded = true;
            } else if (hasChildAlready){
                loaded = true;
            }
        }
        iframe.id = 'spotOffer';
        iframe.scrolling = 'no';
        iframe.loading= 'lazy';
        iframe.style.border = 'none';
        iframe.style.overlow = 'hidden';
        iframe.style.height = '100%';
        iframe.style.position = 'absolute';
        iframe.style.background = 'transparent';
        document.body.appendChild(iframe);
        setTimeout(() => {
            const hasChildAlready = document.getElementById('pdpIframe').querySelector('iframe');
            if(hasChildAlready === null){
                document.getElementById('pdpIframe').append(document.getElementById('spotOffer'));
            }
        },1500);
    }

    document.onload = document.addEventListener('readystatechange', e => {
        if (e.target.readyState === 'complete') {
            loadDeferredIframe(); 
        }
    });
}



// WEBPACK FOOTER //
// ./ldp/common_platform/critical_components/pdp_offer.js